// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__8SjI5","wrapper":"style__wrapper__t4+pj"};